<template>
  <div class="share-success">
    <header class="share-success__header">
      <img
        :src="require('images/voicemod-and-msi-logo.svg')"
        alt="Voicemod and MSI Logo"
      >
    </header>
    <main class="share-success__container">
      <div class="share-success__container__cta">
        <div class="share-success__container__cta__title_container">
          <h1>{{ $t('shareSuccesHalloween.title') }}</h1>
          <h2 class="orange-text">
            {{ $t('shareSuccesHalloween.subtitle') }}
          </h2>
        </div>
        <div class="share-success__container__cta__ornamental-left">
          <img
            class="share-success__container__cta__ornamental-left--subject"
            :src="require('images/halloween_img_tiktok.png')"
            alt="Share CTA Scream"
          >
        </div>
        <div class="share-success__container__cta__ornamental-rigth">
          <img
            class="share-success__container__cta__ornamental-rigth--subject"
            :src="require('images/halloween_img_instagram.png')"
            alt="Share CTA Scream 2"
          >
        </div>
        <p>
          {{ $t('shareSuccesHalloween.descriptionPartOne') }} <span class="orange-text">{{ $t('shareSuccesHalloween.descriptionPartTwo') }}</span> <br>
          {{ $t('shareSuccesHalloween.descriptionThree') }} <span class="orange-text">{{ $t('shareSuccesHalloween.descriptionFour') }}</span> {{ $t('shareSuccesHalloween.descriptionFive') }}
        </p>
      </div>
      <div class="share-success__container__background-text" />
      <div class="share-success__container__socials">
        <img
          :src="require('images/halloween_img_tiktok.png')"
          alt="Share CTA Scream"
        >
        <img
          :src="require('images/halloween_img_instagram.png')"
          alt="Share CTA Scream 2"
        >
      </div>
    </main>
    <footer>
      <p>
        {{ $t('shareSuccesHalloween.footerTitle') }} <a
          aria-label="Download Voicemod"
          @click="goToDownloadApp"
        >{{ $t('shareSuccesHalloween.footerCTA') }}</a>
      </p>
    </footer>
    <!-- ORNAMENTS -->
    <div class="share-success__left-ornament">
      <img
        :src="require('images/voicemod-lateral-ornament.svg')"
        alt="Voicemod and MSI Lateral Ornament"
      >
    </div>
    <div class="share-success__right-ornament">
      <img
        :src="require('images/voicemod-and-msi-lateral-ornament.svg')"
        alt="Voicemod and MSI Lateral Ornament"
      >
    </div>
  </div>
</template>

<script>
import { ROUTER_PATHS } from '@/router/paths';
import { LOGIN_ACTIONS_CONSTANTS } from '@/domain/login';
import { mParticleMetric } from '@/metrics';
import { CookieService } from '@/services/cookie';

export default {
    name: 'ShareSuccessView',
    mounted() {
        mParticleMetric.track(mParticleMetric.EVENTS.HALLOWEN_SHARE_VIEW, {
            voicemod_system: 'account.voicemod.net',
            page_url_path: '/share-success',
            logged_in: true,
            user_id: this.getUserId(),
        });
    },
    methods:{
        getUserId() {
            return CookieService.getCookie('userId');
        },
        goToDownloadApp() {
            mParticleMetric.track(mParticleMetric.EVENTS.WEB_CLICK, {
                voicemod_system: 'account.voicemod.net',
                web_button_name: this.$t('shareSuccesHalloween.footerCTA'),
                page_url_path: '/share-success',
                logged_in: true,
                user_id: this.getUserId(),
            });

            this.$router.push({
                path: ROUTER_PATHS.HOME,
                query: {
                    action: LOGIN_ACTIONS_CONSTANTS.DOWNLOAD,
                },
            });
        },
    },
};
</script>

<style src="./ShareSuccessView.scss" lang="scss"></style>
